/**
 * Tiny helpers shared by the admin platforms page split.
 */
export function relTime(iso) {
    if (!iso) return 'never';
    try {
        const d = new Date(iso);
        const ms = d.getTime();
        if (!Number.isFinite(ms)) return 'unknown';
        const diff = Math.max(0, Date.now() - ms);
        const mins = Math.floor(diff / 60000);
        if (mins < 1) return 'just now';
        if (mins < 60) return `${mins} min ago`;
        const hrs = Math.floor(mins / 60);
        if (hrs < 24) return `${hrs} hr ago`;
        const days = Math.floor(hrs / 24);
        return `${days} day${days > 1 ? 's' : ''} ago`;
    } catch { return 'unknown'; }
}

export const PLATFORM_HELP = {
    olaparty: {
        login_url: 'https://www.olaparty.com/a/agent-recharge/',
        site: 'https://www.olaparty.com',
        note: 'Log into your Olaparty (Qwick Live) agency portal in your browser, export cookies as cookies.txt and drop it here.',
    },
    trumeet: {
        login_url: 'https://www.trumeet.net/a/trumeet-recharge-of-agent/',
        site: 'https://www.trumeet.net',
        note: 'Log into your Trumeet agency portal in your browser, export cookies as cookies.txt and drop it here.',
    },
};

export const PLACEHOLDERS = ['{in_app_id}', '{amount}', '{platform}', '{source_ref}'];
